import { CredentialsKeyEnum } from '../../../types';
import { AWS_CLAUDE_COMMERCIAL_REGIONS } from '../../aws-claude-regions';
const mailConfigBase = [
    {
        key: CredentialsKeyEnum.From,
        displayName: 'From email address',
        description: 'Use the same email address you used to authenticate your delivery provider',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SenderName,
        displayName: 'Sender name',
        type: 'string',
        required: true,
    },
];
const smsConfigBase = [
    {
        key: CredentialsKeyEnum.From,
        displayName: 'From',
        type: 'string',
        required: true,
    },
];
const pushConfigBase = [];
export const mailJsConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Secret key',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const mailgunConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.BaseUrl,
        displayName: 'Base URL',
        type: 'string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.User,
        displayName: 'User name',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Domain,
        displayName: 'Domain',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const mailjetConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'API Secret',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const nexmoConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'API secret',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const mandrillConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
function isPlainJsonObject(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function isTlsOptionsValue(value) {
    if (value == null || value === '') {
        return true;
    }
    if (typeof value === 'string') {
        try {
            return isPlainJsonObject(JSON.parse(value));
        }
        catch {
            return false;
        }
    }
    return isPlainJsonObject(value);
}
export const nodemailerConfig = [
    {
        key: CredentialsKeyEnum.User,
        displayName: 'User',
        type: 'string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.Password,
        displayName: 'Password',
        type: 'string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.Host,
        displayName: 'Host',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Port,
        displayName: 'Port',
        type: 'number',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Secure,
        displayName: 'Secure',
        type: 'switch',
        required: false,
    },
    {
        key: CredentialsKeyEnum.RequireTls,
        displayName: 'Require TLS',
        type: 'switch',
        required: false,
    },
    {
        key: CredentialsKeyEnum.IgnoreTls,
        displayName: 'Ignore TLS',
        type: 'switch',
        required: false,
    },
    {
        key: CredentialsKeyEnum.TlsOptions,
        displayName: 'TLS options',
        description: 'One JSON object of Node.js TLS settings. Used only when Secure is on.',
        placeholder: '{"minVersion":"TLSv1.2"}',
        type: 'textarea',
        required: false,
        validation: {
            validate: (value) => {
                if (isTlsOptionsValue(value)) {
                    return true;
                }
                return 'TLS options must be a JSON object.';
            },
        },
    },
    {
        key: CredentialsKeyEnum.Domain,
        displayName: 'DKIM: Domain name',
        type: 'string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'DKIM: Private key',
        type: 'string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.AccountSid,
        displayName: 'DKIM: Key selector',
        type: 'string',
        required: false,
    },
    ...mailConfigBase,
];
export const postmarkConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const sendgridConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Region,
        displayName: 'Region',
        description: 'Select EU if your SendGrid account is hosted in the EU data center',
        type: 'dropdown',
        required: false,
        value: 'global',
        dropdown: [
            { name: 'Global (US)', value: 'global' },
            { name: 'EU', value: 'eu' },
        ],
    },
    {
        key: CredentialsKeyEnum.IpPoolName,
        displayName: 'IP Pool Name',
        type: 'string',
        required: false,
    },
    ...mailConfigBase,
];
export const resendConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const anypostConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const mailtrapConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const plunkConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const sparkpostConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Region,
        displayName: 'Region',
        description: 'Use EU if your account is registered to SparkPost EU',
        type: 'dropdown',
        required: false,
        value: null,
        dropdown: [
            { name: 'Default', value: null },
            { name: 'EU', value: 'eu' },
        ],
    },
    ...mailConfigBase,
];
export const netCoreConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const sendinblueConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const sesConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'Access key ID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Secret access key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Region,
        displayName: 'Region',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ConfigurationSetName,
        displayName: 'Configuration Set Name',
        description: 'The name of the SES Configuration Set to apply to sent emails',
        type: 'string',
        required: false,
    },
    ...mailConfigBase,
];
export const mailerSendConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const plivoConfig = [
    {
        key: CredentialsKeyEnum.AccountSid,
        displayName: 'Account SID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Token,
        displayName: 'Auth token',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const sms77Config = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const termiiConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const burstSmsConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'API Secret',
        type: 'string',
        required: true,
    },
];
export const bulkSmsConfig = [
    {
        key: CredentialsKeyEnum.ApiToken,
        displayName: 'API Token',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.From,
        displayName: 'Sender ID',
        description: 'Sender Id is used for from field in the request. If not provided, from field will not be sent in the request',
        type: 'string',
        required: false,
    },
];
export const iSendSmsConfig = [
    {
        key: CredentialsKeyEnum.ApiToken,
        displayName: 'API Token',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.From,
        displayName: 'Default Sender ID',
        type: 'string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.ContentType,
        displayName: 'Content Type',
        type: 'dropdown',
        required: false,
        value: null,
        dropdown: [
            { name: 'Default', value: null },
            { name: 'Unicode', value: 'unicode' },
            { name: 'Plain', value: 'plain' },
        ],
    },
];
export const clickatellConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
];
export const snsConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'Access key ID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Secret access key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Region,
        displayName: 'AWS region',
        type: 'string',
        required: true,
    },
];
export const telnyxConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.MessageProfileId,
        displayName: 'Message profile ID',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const twilioConfig = [
    {
        key: CredentialsKeyEnum.AccountSid,
        displayName: 'Account SID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.AuthMethod,
        displayName: 'Authentication method',
        description: 'Use an API key to avoid sharing your account auth token. The key needs permission to create messages.',
        type: 'dropdown',
        required: false,
        value: null,
        dropdown: [
            { name: 'Auth token', value: null },
            { name: 'API key', value: 'apiKey' },
        ],
    },
    {
        key: CredentialsKeyEnum.Token,
        displayName: 'Auth token',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key SID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'API Key Secret',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Region,
        displayName: 'Data residency region',
        description: 'Select EU if your Twilio account uses EU data residency (IE1). Use region-specific credentials.',
        type: 'dropdown',
        required: false,
        value: 'us',
        dropdown: [
            { name: 'US (default)', value: 'us' },
            { name: 'EU (Ireland)', value: 'eu' },
        ],
    },
    ...smsConfigBase,
];
export const messagebirdConfig = [
    {
        key: CredentialsKeyEnum.AccessKey,
        displayName: 'Access key',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const slackConfigLegacy = [
    {
        key: CredentialsKeyEnum.ApplicationId,
        displayName: 'App ID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ClientId,
        displayName: 'Client ID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Client Secret',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SigningSecret,
        displayName: 'Signing Secret',
        description: 'Slack app Signing Secret, used for verifying inbound webhook requests',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.RedirectUrl,
        displayName: 'Redirect URL',
        description: 'Redirect after Slack OAuth flow finished (default behaviour will close the tab)',
        type: 'string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.Hmac,
        displayName: 'HMAC',
        type: 'switch',
        required: false,
    },
];
export const slackConfig = [
    {
        key: CredentialsKeyEnum.ApplicationId,
        displayName: 'App ID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ClientId,
        displayName: 'Client ID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Client Secret',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SigningSecret,
        displayName: 'Signing Secret',
        description: 'Slack app Signing Secret, used for verifying inbound webhook requests',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.RedirectUrl,
        displayName: 'Redirect URL',
        description: 'Redirect after Slack OAuth flow finished (default behaviour will close the tab)',
        type: 'string',
        required: false,
    },
];
export const msTeamsConfig = [
    {
        key: CredentialsKeyEnum.ClientId,
        displayName: 'Microsoft App ID',
        description: 'From Azure Bot resource → Configuration, or App Registration → Overview (Application client ID)',
        type: 'string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Client Secret',
        description: 'Secret value from App Registration → Certificates & secrets → New client secret',
        type: 'string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.TenantId,
        displayName: 'Directory (tenant) ID',
        description: 'From App Registration → Overview (Directory tenant ID)',
        type: 'string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.RedirectUrl,
        displayName: 'Redirect URL',
        description: 'Redirect after Teams OAuth flow finished (default behaviour will close the tab)',
        type: 'string',
        required: false,
    },
];
export const grafanaOnCallConfig = [
    {
        key: CredentialsKeyEnum.alertUid,
        displayName: 'Alert UID',
        type: 'string',
        description: 'a unique alert ID for grouping, maps to alert_uid of grafana webhook body content',
        required: false,
    },
    {
        key: CredentialsKeyEnum.title,
        displayName: 'Title.',
        type: 'string',
        description: 'title for the alert',
        required: false,
    },
    {
        key: CredentialsKeyEnum.imageUrl,
        displayName: 'Image URL',
        type: 'string',
        description: 'a URL for an image attached to alert, maps to image_url of grafana webhook body content',
        required: false,
    },
    {
        key: CredentialsKeyEnum.state,
        displayName: 'Alert State',
        type: 'string',
        description: 'either "ok" or "alerting". Helpful for auto-resolving',
        required: false,
    },
    {
        key: CredentialsKeyEnum.externalLink,
        displayName: 'External Link',
        type: 'string',
        description: 'link back to your monitoring system, maps to "link_to_upstream_details" of grafana webhook body content',
        required: false,
    },
];
export const getstreamConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
];
export const fcmConfig = [
    {
        key: CredentialsKeyEnum.ServiceAccount,
        displayName: 'Service Account (entire JSON file)',
        type: 'textarea',
        required: true,
        validation: {
            validate: (value) => {
                if (!value || value.trim() === '') {
                    return true; // Let required validation handle empty values
                }
                try {
                    JSON.parse(value);
                    return true;
                }
                catch {
                    return 'Invalid JSON format. Please provide a valid JSON service account file.';
                }
            },
        },
    },
    ...pushConfigBase,
];
export const expoConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'Access Token',
        type: 'text',
        required: true,
    },
    ...pushConfigBase,
];
export const pushWebhookConfig = [
    {
        key: CredentialsKeyEnum.WebhookUrl,
        displayName: 'Webhook URL',
        type: 'string',
        description: 'the webhook URL to call to trigger push notifications',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Secret Hmac Key',
        type: 'string',
        description: 'the secret used to sign webhooks calls',
        required: true,
    },
    ...pushConfigBase,
];
export const chatWebhookConfig = [
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Secret Hmac Key',
        type: 'string',
        description: 'the secret used to sign webhooks calls',
        required: false,
    },
];
export const oneSignalConfig = [
    {
        key: CredentialsKeyEnum.ApplicationId,
        displayName: 'Application ID',
        type: 'text',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'text',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ApiVersion,
        displayName: 'One Signal API',
        description: 'Select the One Signal API to use',
        type: 'dropdown',
        required: false,
        value: null,
        dropdown: [
            { name: 'Default (Player Model)', value: 'playerModel' },
            { name: 'External ID', value: 'externalId' },
        ],
    },
    ...pushConfigBase,
];
export const pushpadConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'Auth Token',
        type: 'text',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ApplicationId,
        displayName: 'Project ID',
        type: 'text',
        required: true,
    },
    ...pushConfigBase,
];
export const apnsConfig = [
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Private Key',
        type: 'textarea',
        required: true,
        validation: {
            validate: (value) => {
                try {
                    // Check if it's a valid PEM format
                    if (!value.includes('-----BEGIN PRIVATE KEY-----') || !value.includes('-----END PRIVATE KEY-----')) {
                        return 'Invalid private key format. Must be in PEM format.';
                    }
                    return true;
                }
                catch {
                    return 'Invalid private key format. Must be in PEM format.';
                }
            },
        },
    },
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'Key ID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ProjectName,
        displayName: 'Team ID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ApplicationId,
        displayName: 'Bundle ID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Secure,
        displayName: 'Production',
        type: 'switch',
        required: false,
    },
    ...pushConfigBase,
];
export const gupshupConfig = [
    {
        key: CredentialsKeyEnum.User,
        displayName: 'User id',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Password,
        displayName: 'Password',
        type: 'string',
        required: true,
    },
];
export const firetextConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const outlook365Config = [
    {
        key: CredentialsKeyEnum.Password,
        displayName: 'Password',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const infobipSMSConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.BaseUrl,
        displayName: 'Base URL',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const infobipEmailConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.BaseUrl,
        displayName: 'Base URL',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const brazeEmailConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ApiURL,
        displayName: 'Base URL',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.AppID,
        displayName: 'App ID',
        type: 'string',
        required: true,
    },
    ...mailConfigBase,
];
export const fortySixElksConfig = [
    {
        key: CredentialsKeyEnum.User,
        displayName: 'Username',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Password,
        displayName: 'Password',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const kannelConfig = [
    {
        key: CredentialsKeyEnum.Host,
        displayName: 'Host',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Port,
        displayName: 'Port',
        type: 'number',
        required: true,
    },
    {
        key: CredentialsKeyEnum.User,
        displayName: 'Username',
        type: 'string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.Password,
        displayName: 'Password',
        type: 'string',
        required: false,
    },
    ...smsConfigBase,
];
export const maqsamConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'Access Key ID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Access Secret',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const smsCentralConfig = [
    {
        key: CredentialsKeyEnum.User,
        displayName: 'Username',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Password,
        displayName: 'Password',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.BaseUrl,
        displayName: 'Base URL',
        type: 'string',
        required: false,
    },
    ...smsConfigBase,
];
export const emailWebhookConfig = [
    {
        key: CredentialsKeyEnum.WebhookUrl,
        displayName: 'Webhook URL',
        type: 'string',
        description: 'the webhook URL to call instead of sending the email',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Secret Hmac Key',
        type: 'string',
        description: 'the secret used to sign webhooks calls',
        required: true,
    },
    {
        key: CredentialsKeyEnum.HmacSecretKeyEncoding,
        displayName: 'Secret Hmac Key Encoding',
        type: 'dropdown',
        description: 'how the Secret Hmac Key is interpreted when signing webhook calls — Base-64/HEX for binary keys (e.g. AWS KMS)',
        required: false,
        value: 'text',
        dropdown: [
            { name: 'Text', value: 'text' },
            { name: 'Base-64', value: 'base64' },
            { name: 'HEX', value: 'hex' },
        ],
    },
    ...mailConfigBase,
];
export const africasTalkingConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.User,
        displayName: 'Username',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const novuInAppConfig = [
    {
        key: CredentialsKeyEnum.Hmac,
        displayName: 'Security HMAC encryption',
        type: 'switch',
        required: false,
        tooltip: {
            text: 'When active it verifies if a request is performed by a specific user',
            when: false,
        },
    },
];
/** Mirrors Inbox HMAC toggle — optional per-session agent authorization for Web Chat. */
export const novuWebChatConfig = novuInAppConfig;
export const sendchampConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const clickSendConfig = [
    {
        key: CredentialsKeyEnum.User,
        displayName: 'Username',
        description: 'Your Clicksend API username',
        type: 'text',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'text',
        required: true,
    },
    ...smsConfigBase,
];
export const simpleTextingConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'text',
        required: true,
    },
    ...smsConfigBase,
];
export const bandwidthConfig = [
    {
        key: CredentialsKeyEnum.User,
        displayName: 'Username',
        description: 'Your Bandwidth account username',
        type: 'text',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Password,
        displayName: 'Password',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.AccountSid,
        displayName: 'Account ID',
        type: 'text',
        required: true,
    },
    ...smsConfigBase,
];
export const genericSmsConfig = [
    {
        key: CredentialsKeyEnum.BaseUrl,
        displayName: 'Base URL',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ApiKeyRequestHeader,
        displayName: 'API Key Request Header',
        type: 'string',
        description: 'The name of the header attribute to use for the API key ex. (X-API-KEY, apiKey, ...)',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        description: 'The value of the header attribute to use for the API key.',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKeyRequestHeader,
        displayName: 'Secret Key Request Header',
        type: 'string',
        description: 'The name of the header attribute to use for the secret key ex. (X-SECRET-KEY, secretKey, ...)',
        required: false,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Secret Key',
        type: 'string',
        description: 'The value of the header attribute to use for the secret key',
        required: false,
    },
    {
        key: CredentialsKeyEnum.IdPath,
        displayName: 'Id Path',
        type: 'string',
        value: 'data.id',
        description: 'The path to the id field in the response data ex. (id, message.id, ...)',
        required: true,
    },
    {
        key: CredentialsKeyEnum.DatePath,
        displayName: 'Date Path',
        type: 'string',
        value: 'data.date',
        description: 'The path to the date field in the response data ex. (date, message.date, ...)',
        required: false,
    },
    {
        key: CredentialsKeyEnum.AuthenticateByToken,
        displayName: 'Authenticate by token',
        type: 'switch',
        description: 'If enabled, the API key and secret key will be sent as a token in the Authorization header',
        required: false,
    },
    {
        key: CredentialsKeyEnum.Domain,
        displayName: 'Auth URL',
        type: 'string',
        description: 'The URL to use for authentication in case the Authenticate by token option is enabled',
        required: false,
        tooltip: {
            text: 'The URL to use for authentication in case the Authenticate by token option is enabled',
            when: true,
        },
    },
    {
        key: CredentialsKeyEnum.AuthenticationTokenKey,
        displayName: 'Authentication Token Key',
        type: 'string',
        description: 'The name of the header attribute to use for the authentication token ex. (X-AUTH-TOKEN, auth-token, ...)',
        required: false,
    },
    ...smsConfigBase,
];
export const pusherBeamsConfig = [
    {
        key: CredentialsKeyEnum.InstanceId,
        displayName: 'Instance ID',
        description: 'The unique identifier for your Beams instance',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Secret Key',
        description: 'The secret key your server will use to access your Beams instance',
        type: 'string',
        required: true,
    },
    ...pushConfigBase,
];
export const azureSmsConfig = [
    {
        key: CredentialsKeyEnum.AccessKey,
        displayName: 'Connection string',
        description: 'Your Azure account connection string',
        type: 'text',
        required: true,
    },
    ...smsConfigBase,
];
export const rocketChatConfig = [
    {
        key: CredentialsKeyEnum.Token,
        displayName: 'Personal Access Token (x-auth-token)',
        description: 'Personal Access Token of your user',
        type: 'text',
        required: true,
    },
    {
        key: CredentialsKeyEnum.User,
        displayName: 'User id (x-user-id)',
        description: 'Your User id',
        type: 'text',
        required: true,
    },
];
export const ringCentralConfig = [
    {
        key: CredentialsKeyEnum.ClientId,
        displayName: 'Client ID',
        description: 'Your RingCentral app client ID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Client secret',
        description: 'Your RingCentral app client secret',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Secure,
        displayName: 'Is sandbox',
        type: 'switch',
        required: false,
    },
    {
        key: CredentialsKeyEnum.Token,
        displayName: 'JWT token',
        description: 'Your RingCentral user JWT token',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const brevoSmsConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const eazySmsConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.channelId,
        displayName: 'SMS Channel Id',
        type: 'string',
        required: true,
        description: 'Your SMS Channel Id',
    },
];
export const iMediaConfig = [
    {
        key: CredentialsKeyEnum.Token,
        displayName: 'API Token',
        type: 'string',
        required: true,
        description: 'Your iMedia API token',
    },
    ...smsConfigBase,
];
export const whatsAppBusinessConfig = [
    {
        key: CredentialsKeyEnum.ApiToken,
        displayName: 'Access API token',
        description: 'Your WhatsApp Business access API token',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.phoneNumberIdentification,
        displayName: 'Phone Number Identification',
        description: 'Your WhatsApp Business phone number identification',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.businessAccountId,
        displayName: 'WhatsApp Business Account ID',
        description: 'Shown directly above the Phone Number ID on the API Setup page in your Meta app',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'App Secret',
        description: 'In your Meta app, open App settings > Basic from the bottom of the left sidebar — used to verify inbound webhook signatures',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Token,
        displayName: 'Verify Token',
        description: 'Auto-generated by Novu — used to verify the webhook handshake with Meta',
        type: 'string',
        required: false,
        hidden: true,
    },
];
export const sendblueConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        description: 'Your Sendblue API key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Secret Key',
        description: 'Your Sendblue secret key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.From,
        displayName: 'From Number',
        description: 'One of your registered Sendblue phone numbers to send messages from, in E.164 format',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Token,
        displayName: 'Webhook Secret',
        description: 'Auto-generated by Novu — used to verify inbound Sendblue webhook signatures',
        type: 'string',
        required: false,
        hidden: true,
    },
];
export const photonImessageConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'Project ID',
        description: 'Your Photon project ID from app.photon.codes',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Project Secret',
        description: 'Your Photon project secret from app.photon.codes',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Token,
        displayName: 'Webhook Signing Secret',
        description: 'Issued by Photon when the inbound webhook is registered — filled in automatically by "Configure webhook", or paste it here after adding the webhook manually in the Photon dashboard',
        type: 'string',
        required: false,
    },
];
export const lineConfig = [
    {
        key: CredentialsKeyEnum.ApiToken,
        displayName: 'Channel Access Token',
        description: 'Your LINE Channel Access Token from the LINE Developers Console',
        type: 'string',
        required: true,
    },
];
export const mobishastraConfig = [
    {
        key: CredentialsKeyEnum.BaseUrl,
        displayName: 'Base URL',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.User,
        displayName: 'Username',
        type: 'string',
        description: 'Username provided by Mobishatra',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Password,
        displayName: 'Password',
        type: 'string',
        description: ' provided by Mobishastra',
        required: true,
    },
    ...smsConfigBase,
];
export const afroSmsConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SenderName,
        displayName: 'Sender Name',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const unifonicConfig = [
    {
        key: CredentialsKeyEnum.AppSid,
        displayName: 'App SID',
        description: 'Authentication string that uniquely identifies your application.',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.SenderId,
        displayName: 'Sender ID',
        description: 'The SenderID identifies who has sent the SMS message, typically a brand name',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const smsmodeProviderConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        description: 'API key provided by smsmode',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const appIOConfig = [
    {
        key: CredentialsKeyEnum.AppIOBaseUrl,
        displayName: 'Base URL',
        description: 'Base URL of the App IO API (e.g., https://api.io.italia.it/api/v1)',
        type: 'text',
        required: true,
    },
    ...pushConfigBase,
];
export const sinchConfig = [
    {
        key: CredentialsKeyEnum.ServicePlanId,
        displayName: 'Service Plan ID',
        description: 'Your Sinch Service Plan ID',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ApiToken,
        displayName: 'API Token',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.Region,
        displayName: 'Region',
        description: 'Select your Sinch region',
        type: 'dropdown',
        required: true,
        value: 'eu',
        dropdown: [
            { name: 'EU (Ireland, Sweden)', value: 'eu' },
            { name: 'US', value: 'us' },
            { name: 'Australia', value: 'au' },
            { name: 'Brazil', value: 'br' },
            { name: 'Canada', value: 'ca' },
        ],
    },
    ...smsConfigBase,
];
export const ISendProProviderConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        description: 'This is API key for example provider',
        type: 'text',
        required: true,
    },
    {
        key: CredentialsKeyEnum.From,
        displayName: 'Sender',
        description: 'The sender of sms',
        type: 'text',
        required: false,
    },
];
export const cmTelecomConfig = [
    {
        key: CredentialsKeyEnum.ApiToken,
        displayName: 'Product Token',
        description: 'Your CM.com product token',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const ruachSmsConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'API Key',
        description: 'Your Ruach SMS API key',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ClientId,
        displayName: 'Client ID',
        description: 'Your Ruach SMS client identifier',
        type: 'string',
        required: true,
    },
    ...smsConfigBase,
];
export const telegramConfig = [
    {
        key: CredentialsKeyEnum.ApiToken,
        displayName: 'Bot Token',
        description: 'Create a bot in Telegram by chatting with BotFather, then paste the HTTP API token it gives you here.',
        type: 'string',
        required: true,
        links: [{ text: 'BotFather', url: 'https://t.me/botfather' }],
    },
];
export const webexMessagingConfig = [
    {
        key: CredentialsKeyEnum.ClientId,
        displayName: 'Client ID',
        description: 'Webex integration client ID used for OAuth authorization.',
        type: 'string',
        required: true,
        links: [{ text: 'Webex integrations', url: 'https://developer.webex.com/docs/integrations' }],
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Client Secret',
        description: 'Webex integration client secret used to exchange OAuth authorization codes.',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.RedirectUrl,
        displayName: 'Redirect URL',
        description: 'Redirect after the Webex OAuth flow finishes. If omitted, Novu shows a success page.',
        type: 'string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.BaseUrl,
        displayName: 'Base URL',
        description: 'Optional Webex API base URL. Leave empty to use https://webexapis.com/v1.',
        placeholder: 'https://webexapis.com/v1',
        type: 'text',
        required: false,
    },
];
// ─── Agent Runtime Providers ─────────────────────────────────────────────────
export const anthropicAgentConfig = [
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'Anthropic API Key',
        description: 'Your Anthropic API key. Used to authenticate with the Anthropic platform.',
        placeholder: 'sk-ant-...',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ExternalEnvironmentId,
        displayName: 'Anthropic Environment ID',
        description: 'The Anthropic environment ID auto-provisioned for this integration. Read-only.',
        type: 'string',
        required: false,
    },
];
export const anthropicAwsAgentConfig = [
    {
        key: CredentialsKeyEnum.Region,
        displayName: 'AWS Region',
        description: 'The AWS region where your Claude Platform workspace is provisioned.',
        type: 'dropdown',
        required: true,
        dropdown: AWS_CLAUDE_COMMERCIAL_REGIONS.map((region) => ({ name: region, value: region })),
    },
    {
        key: CredentialsKeyEnum.ApiKey,
        displayName: 'AWS API Key',
        description: 'API key generated in the AWS Console under Claude Platform on AWS.',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ExternalWorkspaceId,
        displayName: 'Workspace ID',
        description: 'Claude Platform on AWS workspace ID (`wrkspc_…`). Required for agent runtime dispatch.',
        type: 'string',
        required: true,
    },
    {
        key: CredentialsKeyEnum.ExternalEnvironmentId,
        displayName: 'Environment ID',
        description: 'The environment ID auto-provisioned for this integration. Read-only.',
        type: 'string',
        required: false,
    },
];
/**
 * PagerDuty is routed per subscriber — the routing key and region live on the
 * per-subscriber `ChannelConnection.auth`, provisioned via
 * `POST /v1/channel-endpoints` with `type: pagerduty_service`. The env-level
 * integration record is an anchor only (identifier + name); no fields are
 * configured on the integration itself.
 */
export const pagerdutyConfig = [];
/**
 * Opsgenie is routed per subscriber: the API integration key and region live
 * on the per-subscriber `ChannelConnection.auth`, provisioned via
 * `POST /v1/channel-endpoints` with `type: opsgenie_integration`. The env-level
 * integration record is an anchor only (identifier + name); no fields are
 * configured on the integration itself.
 */
export const opsgenieConfig = [];
/**
 * Grafana is routed per subscriber: the IRM/OnCall incoming-webhook URL and
 * optional bearer token live encrypted on the per-subscriber
 * `ChannelEndpoint.endpoint`, provisioned via `POST /v1/channel-endpoints`
 * with `type: grafana_oncall_integration`. The env-level integration record
 * is an anchor only (identifier + name); no fields are configured on the
 * integration itself.
 */
export const grafanaConfig = [];
export const toolWebhookConfig = [
    {
        key: CredentialsKeyEnum.RoutingMode,
        displayName: 'Routing Mode',
        type: 'dropdown',
        description: 'Static delivers to one integration URL; dynamic routes per subscriber endpoint',
        required: false,
        value: 'static',
        dropdown: [
            { name: 'Static', value: 'static' },
            { name: 'Dynamic', value: 'dynamic' },
        ],
    },
    {
        key: CredentialsKeyEnum.Method,
        displayName: 'HTTP Method',
        type: 'dropdown',
        required: true,
        value: 'POST',
        dropdown: [
            { name: 'POST', value: 'POST' },
            { name: 'PUT', value: 'PUT' },
            { name: 'PATCH', value: 'PATCH' },
        ],
    },
    {
        key: CredentialsKeyEnum.WebhookUrl,
        displayName: 'Endpoint URL',
        type: 'string',
        description: 'Webhook URL used in static routing mode',
        required: false,
    },
    {
        key: CredentialsKeyEnum.Headers,
        displayName: 'Headers',
        type: 'textarea',
        description: 'Default request headers as a JSON key/value object string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.Body,
        displayName: 'Body',
        type: 'textarea',
        description: 'Default request body as a JSON key/value object string',
        required: false,
    },
    {
        key: CredentialsKeyEnum.SecretKey,
        displayName: 'Signing Secret',
        type: 'string',
        description: 'Optional HMAC secret used to sign webhook calls (X-Novu-Signature)',
        required: false,
    },
];
//# sourceMappingURL=provider-credentials.js.map